import { createPortal } from 'react-dom';

export type PortalProps = {
  children: React.ReactNode;
};

export const Portal = ({ children }: PortalProps) => {
  return createPortal(children, document.body);
};
